import { render, staticRenderFns } from "./SummaryComponent.vue?vue&type=template&id=3177308e&scoped=true&"
import script from "./SummaryComponent.vue?vue&type=script&lang=js&"
export * from "./SummaryComponent.vue?vue&type=script&lang=js&"
import style0 from "./SummaryComponent.vue?vue&type=style&index=0&id=3177308e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3177308e",
  null
  
)

export default component.exports